import { Component, OnInit, Inject } from '@angular/core';
import {  MatInputModule, MatFormFieldModule, MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent {
  msg: string;
  constructor(
    public dialogRef: MatDialogRef<ErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.msg = data.errorMsg;
  }

  onCloseDialog() {
    this.dialogRef.close();
}
}




// WEBPACK FOOTER //
// ./src/app/shared/components/error-dialog/error-dialog.component.ts